var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"press-release-block"},[_c('h6',[_vm._v(_vm._s(_vm.data.time))]),_c('h4',[_c('b-link',{attrs:{"href":_vm.data.link,"title":""},on:{"click":function($event){return _vm.onclick(_vm.data.link)}}},[_vm._v(_vm._s(_vm.data.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }